import React, { useState } from 'react';
import CognitoAuthService from '../services/CognitoAuthService';
import { API_BASE_URL } from '../config';

function ConfirmUser({ isOpen, onClose, email, username, onConfirmationSuccess }) {
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const cognitoService = new CognitoAuthService();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!verificationCode.trim()) {
      setError('Please enter the verification code');
      return;
    }
    
    console.log('User entered verification code:', verificationCode, 'at', new Date().toISOString());
    console.log('Attempting to confirm user with email:', email);
    
    setLoading(true);
    setError('');
    
    try {
      // 1. 确认Cognito用户 - 使用正确的 username
      console.log('Confirming user with username:', username, 'and code:', verificationCode);
      await cognitoService.confirmUser(username, verificationCode);
      
      // 2. 同步到数据库
      try {
        const syncResponse = await fetch(`${API_BASE_URL}/api/confirm-cognito-user`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            verificationCode: verificationCode
          })
        });
        
        if (syncResponse.ok) {
          const syncData = await syncResponse.json();
          console.log('User confirmed and synced:', syncData);
        } else {
          console.warn('Failed to sync confirmed user to database:', await syncResponse.text());
        }
      } catch (syncError) {
        console.warn('Database sync error:', syncError);
      }
      
      setSuccess(true);
      setTimeout(() => {
        onClose();
        if (onConfirmationSuccess) {
          onConfirmationSuccess();
        }
      }, 2000);
      
    } catch (err) {
      console.error('Confirmation error:', err);
      setError(err.message || 'Confirmation failed');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setVerificationCode('');
    setError('');
    setSuccess(false);
    onClose();
  };

  console.log('ConfirmUser render - isOpen:', isOpen, 'email:', email);
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header auth-header">
          <button className="close-button-top" onClick={handleClose}>×</button>
          <h2 className="modal-title auth-title">Confirm Your Account</h2>
        </div>
        
        {success ? (
          <div className="auth-form" style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ color: 'green', fontSize: '24px', marginBottom: '10px' }}>✅</div>
            <h3 style={{ color: 'green', marginBottom: '10px' }}>Account Confirmed!</h3>
            <p>Your account has been successfully confirmed. You can now log in.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666' }}>
              We've sent a verification code to <strong>{email}</strong>.
              Please enter the code below to confirm your account.
            </p>
            
            {error && (
              <div className="error-message" style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>
                {error}
              </div>
            )}
            
            <div className="form-group">
              <div className="input-with-label">
                <label htmlFor="verificationCode">Verification Code</label>
                <input
                  type="text"
                  id="verificationCode"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder="Enter 6-digit code"
                  required
                  disabled={loading}
                  style={{ textAlign: 'center', fontSize: '18px', letterSpacing: '2px' }}
                />
              </div>
            </div>
            
            <div className="form-actions">
              <button type="submit" className="auth-submit-button" disabled={loading}>
                {loading ? 'Confirming...' : 'Confirm Account'}
              </button>
            </div>
            
            <div className="auth-footer">
              <p>Didn't receive the code? <span className="link-text" onClick={async () => {
                try {
                  // Resend verification code
                  const cognitoService = new CognitoAuthService();
                  await cognitoService.resendConfirmationCode(email);
                  alert('New verification code sent! Please check your email.');
                } catch (error) {
                  console.error('Error resending code:', error);
                  alert('Failed to resend code. Please try signing up again.');
                }
              }}>Resend Code</span></p>
              <p style={{ marginTop: '10px', fontSize: '12px' }}>
                <span className="link-text" onClick={async () => {
                  try {
                    const cognitoService = new CognitoAuthService();
                    const status = await cognitoService.checkUserConfirmationStatus(email);
                    console.log('User confirmation status check:', status);
                    alert(`User status: ${status.needsConfirmation ? 'Needs confirmation' : 'Already confirmed'} - see console for details`);
                  } catch (error) {
                    console.error('Error checking user status:', error);
                    alert('Error checking user status: ' + error.message);
                  }
                }}>Debug: Check Confirmation Status</span>
              </p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ConfirmUser; 